import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Subscription} from "rxjs";
import {DepotModel} from "../../models/depot.model";
import {DepotsComponentStore} from "../../state/depots-component.store";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import * as angular from "angular";
import {ButtonSizeType} from "../../../../commons/types/button-size.type";

interface DepotsSelectListModel {
  selectedIds: string[];
  branchIds: string[];
  excludeIds: string[];
  ngPlaceholder: any;
  buttonSize: ButtonSizeType;
}


require('./depot-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-depot-select-list',
  templateUrl: './depot-select-list.html',
  providers: [DepotsComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepotSelectListComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<{depot: DepotModel | null}>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public ngPlaceholder: string;
  public branchIds: string[];
  public queryString: string = '';
  public loadLimit: number = 20;
  public depots: DepotModel[] = [];
  public selectedDepot: DepotModel | null;
  public depotsSubscription: Subscription;
  public cursor: string;
  public isLoading: boolean;
  public buttonSize: ButtonSizeType;
  public excludeIds: string[] = [];

  constructor(@Inject(PANEL_DATA) public data: DepotsSelectListModel,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
              @Inject(DepotsComponentStore) private depotsStore: DepotsComponentStore) {
  }

  ngOnInit() {
    this.ngPlaceholder = this.data.ngPlaceholder;
    this.buttonSize = this.data.buttonSize;
    this.excludeIds = this.data.excludeIds;

    const excludedIds = new Set(this.excludeIds);

    this.depotsSubscription = this.depotsStore.vm$.subscribe((vm) => {
      this.cursor = vm.cursor;
      this.isLoading = vm.loading;
      this.depots = vm.depots.filter(
        depot => !excludedIds.has(depot.id)
      );
      this.cdkVirtualScrollViewport?.checkViewportSize();
      this.cdr.detectChanges();
    })

    this._getDepots();
  }

  ngOnDestroy() {
    if(this.depotsSubscription) {
      this.depotsSubscription.unsubscribe();
    }
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getDepots();
    }
  }

  onToggle(depot: DepotModel) {
    this.selectedDepot = angular.copy(depot);
  }

  onSubmit() {
    this.onClose.emit({depot: this.selectedDepot});
  }

  onReset() {
    this.onClose.emit({depot: null});
  }

  onCancel() {
    this.onClose.emit({depot: this.selectedDepot});
  }

  onQueryChange(query) {
    this.queryString = query;
    this._resetStore();
    this._getDepots();
  }

  private _resetStore() {
    this.depotsStore.resetDepots();
  }

  private _getDepots() {
    this.depotsStore.getDepots(this._getQueryPayload());
  }

  private _getQueryPayload() {
    const params = {
      limit: this.loadLimit,
      query: this.queryString,
      branchIds: this.branchIds,
      sort: 'name,asc'
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

}
